import { render, staticRenderFns } from "./BookLanguageSelectorButton.vue?vue&type=template&id=1971446c&"
import script from "./BookLanguageSelectorButton.vue?vue&type=script&lang=js&"
export * from "./BookLanguageSelectorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports